import { Collection } from '../types/collection';
import { at } from './at';

/**
 * Gets the first element from a collection or return `undefined`.
 *
 * @returns `undefined` if the collection is empty, otherwise `A`.
 */
export function first<A>(collection: Collection<A>): A | undefined {
  return at(0, collection);
}
